var map = {
	"./chips.jpg": 75,
	"./cinnabon.jpg": 76,
	"./dessert.jpg": 77,
	"./kids.jpg": 78,
	"./mac.jpg": 79,
	"./pizza.jpg": 80,
	"./salad.jpg": 81,
	"./sandwich.jpg": 82,
	"./soup.jpg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;